import { Text } from "@fscrypto/flip-kit/text";
import { Check } from "lucide-react";
import { buttonVariants } from "../../components/button/button";
import { Dialog, DialogContent, DialogTrigger } from "../../components/dialog/dialog";
import { cn } from "../../utils/cn";

export const ContactUsDialog = ({
  children,
  open,
  setOpen,
}: {
  children?: React.ReactNode;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className={cn(buttonVariants({ variant: "default", font: "mono" }))}>{children}</DialogTrigger>
      <DialogContent className="w-full bg-bg-secondary p-8 dark" showClose>
        <div className="space-y-6">
          <Text variant="body-lg">Contact Us</Text>
          <Text className="block text-text-secondary">
            Whether you're launching a protocol, scaling a product, or leading chain growth, our team can help you
            activate the users that matter most.
          </Text>
          <Text className="block text-text-secondary">
            Looking to access the Flipside Growth MCP?{" "}
            <a href="/chat/" className="underline">
              Register here
            </a>
          </Text>
          <div className="space-y-1">
            <CheckListItem>Book a free session with a growth strategist</CheckListItem>
            <CheckListItem>Learn about Intelligence-Driven Growth</CheckListItem>
            <CheckListItem>Grow your ecosystem</CheckListItem>
          </div>
        </div>
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="4c58d611-de83-4efd-aa4d-e48d75d08b86"
          data-portal-id="24166198"
        />
      </DialogContent>
    </Dialog>
  );
};

export const CheckListItem = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center gap-2">
      <Check className="w-4 h-4 text-brand-3" />
      <span className="text-text-secondary">{children}</span>
    </div>
  );
};
